@for(datum of data; track datum; let index=$index)
{
    <tr [ngClass]="options.rowCssClass?.(datum)" (click)="options.rowClick?.(datum, index)">
        @for(meta of metadata?.columns; track meta)
        {
            <td [ngClass]="meta?.cellClass"
                [attr.data-header-title]="meta?.title">

                @if(meta?.bodyTemplate)
                {
                    <ng-container *ngTemplateOutlet="meta?.bodyTemplate ?? null; context: datum | dataCellContext: index : meta"/>
                }
                @else
                {
                    {{datum | readValue: meta?.name}}
                }
            </td>
        }
    </tr>
}